import { h } from "vue";
const _sfc_main = {
  name: "DtcNode",
  props: {
    template: {
      type: String,
      required: true
    },
    library: {
      type: Object,
      default: () => {
      }
    }
  },
  render(props) {
    return h({
      components: props.library,
      template: props.template
    });
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=node.vue.js.map
